export class PayPalSftpFileState {
    loading = false;
    record: any = {};
}
